<template>
  <div class="mycontainer">
    <div class="itemcontent" v-if="itemlist1">
      <div class="topcontent">
        <div class="lefttitle">通知公告</div>
        <div class="moretitle" @click="moreclick('2')">更多></div>
      </div>

      <div class="bottomcontent">
        <div class="itemclass"
             v-for="(item,index) in itemlist2"
             @click="getInformationById(item.id,'2')"
             :class="{'lastitemclass':Number(index+1)==(itemlist2.length)}">
          <div class="circle"></div>
          <div class="name textline1">{{item.title}}</div>
          <div class="time">{{item.pubdate}}</div>
        </div>
      </div>
    </div>
    <div class="itemcontent">
      <div class="topcontent">
        <div class="lefttitle">国内科技动态</div>
        <div class="moretitle" @click="moreclick('3')">更多></div>
      </div>

      <div class="bottomcontent" v-if="itemlist3">
        <div class="itemclass"
             @click="getInformationById(item.id,'3')"
             v-for="(item,index) in itemlist3"
             :class="{'lastitemclass':Number(index+1)==(itemlist3.length)}">
          <div class="circle"></div>
          <div class="name textline1">{{item.title}}</div>
          <div class="time">{{item.pubdate}}</div>
        </div>
      </div>
    </div>

    <div style="height: 410px;margin-bottom: 0;" class="itemcontent" v-if="itemlist1">
      <div class="topcontent">
        <div class="lefttitle">驻外科技机构推荐项目</div>
        <div class="moretitle" @click="moreclick('1')">更多></div>
      </div>

      <div class="bottomcontent">
        <div class="itemclass1"
             v-for="(item,index) in itemlist1"
             @click="getInformationById(item.id,'1')"
             :class="{'lastitemclass':Number(index+1)==(itemlist1.length)}">
          <div class="timecontent">
            <div class="time1">{{item.time1}}</div>
            <div class="time2">{{item.time2}}</div>
          </div>
          <div class="name textline1">{{item.title}}</div>
        </div>
      </div>
    </div>
    <div style="height: 410px;margin-bottom: 0;" class="itemcontent">
      <div class="topcontent">
        <div class="lefttitle">海外科技动态</div>
        <div class="moretitle" @click="moreclick('4')">更多></div>
      </div>

      <div class="bottomcontent" v-if="itemlist4">
        <div class="itemclass1"
             v-for="(item,index) in itemlist4"
             @click="getInformationById(item.id,'4')"
             :class="{'lastitemclass':Number(index+1)==(itemlist4.length)}">
          <div class="timecontent">
            <div class="time1">{{item.time1}}</div>
            <div class="time2">{{item.time2}}</div>
          </div>
          <div class="name textline1">{{item.title}}</div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
  import * as api from "../../utils/api"
  import axios from "axios";

  export default {
    components: {},
    name: "information",
    data(){
      return{
        loading:false,
        tabnamelist:[],
        tableData: [],
        itemlist1:[],
        type:{0:'国内科创动态,国外科创动态',1:'推荐项目',2:'通知公告',3:'国内科创动态',4:'国外科创动态'},
        itemlist2:[],
        itemlist3:[],
        itemlist4:[],

      }
    },
    mounted() {
      this.getInformationDetail('1');
      this.getInformationDetail('2');
      this.getInformationDetail('3');
      this.getInformationDetail('4');

    },
    methods:{
      getInformationDetail(typeindex) {

        this.loading=true;
        var self = this;
        api.getInformationDetail({
          type:this.type[typeindex],
          startPage:'1',
          endPage: '5'
        })
          .then(rs => {
            self.loading=false;

            if (rs.status == 200) {
              for(var i =0;i<rs.data.list.length;i++){
                var item = rs.data.list[i];


                if(typeindex==2){
                  self.itemlist2=rs.data.list;
                }else if(typeindex==3){
                  self.itemlist3=rs.data.list;
                }else if(typeindex==1){
                  var pubdate = item.pubdate.split('-')
                  if(pubdate.length==3){
                    item.time1=pubdate[0]+'-'+pubdate[1];
                    item.time2=pubdate[2];
                  }
                  self.itemlist1=rs.data.list;
                }else if(typeindex==4){
                  var pubdate = item.pubdate.split('-')
                  if(pubdate.length==3){
                    item.time1=pubdate[0]+'-'+pubdate[1];
                    item.time2=pubdate[2];
                  }
                  self.itemlist4=rs.data.list;
                }
              }


            } else {
              self.$message.error(rs.message)

            }

          })
          .catch(err => {
            self.$message.error(err)
            self.loading=false;

          })
      },
      getInformationById(id,typeIndex){
        this.$router.push({
          name: 'informationdetail',
          query:{
            id:id,
            typeindex:typeIndex
          }
        })
      },

      moreclick(typeIndex){
        this.$router.push({
          name: 'informationlist',
          query:{
            typeindex:typeIndex
          }
        })
      }
    }
  }
</script>

<style lang="less" type="text/less" rel="stylesheet/less" scoped>
  .mycontainer{
    width: 100%;
    /*min-height: calc(100vh - 70px);*/
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .itemcontent{
      width: calc(50% - 10px);
      height: 320px;
      background-color: #ffffff;
      box-shadow: 0px 2px 6px 0px
      #ebf1f4;
      border-radius: 4px;
      margin-bottom: 20px;
      .topcontent{
        display: flex;
        height: 52px;
        border-bottom: 1px solid #e6eaf0;
        padding: 0 20px;
        .lefttitle{
          width: calc(100% - 50px);
          font-size: 17px;
          line-height: 50px;
          color: #2a3138;
          font-weight: bold;
        }
        .moretitle{
          width: 50px;
          font-size: 16px;
          line-height: 50px;
          color: #545d6b;
          text-align: right;
          cursor: pointer;

        }
        .moretitle:hover{
          color:#0a7afc;
        }
      }

      .bottomcontent{

        .lastitemclass{
          border-bottom: 0 !important;

        }
        .itemclass{
          display: flex;
          height: 52px;
          border-bottom: 1px solid #e6eaf0;
          margin: 0 20px;
          cursor: pointer;
          .circle{
            width: 12px;
            height: 12px;
            background-color: #dde4f0;
            border-radius: 6px;
            margin-top: 20px;
            margin-right: 10px;
          }
          .name{
            color: #2a3138;
            font-size: 16px;
            line-height: 52px;
            width: calc(100% - 110px);
          }
          .time{
            color: #808b9e;
            font-size: 16px;
            line-height: 52px;
            text-align: right;
            width: 90px;
          }
          .timecontent{

          }


        }
        .itemclass:hover{
          .circle{
            background-color: #0a7afc;
          }
          .name{
            color: #0a7afc;
          }
          .time{
            color: #0a7afc;
          }
        }


        .itemclass1{
          display: flex;
          height: 70px;
          border-bottom: 1px solid #e6eaf0;
          margin: 0 20px;
          cursor: pointer;
          .timecontent{
            width: 60px;
            height: 70px;
            /*background-color: #dde4f0;*/
            /*border-radius: 6px;*/
            /*margin-top: 20px;*/
            margin-right: 10px;
            .time1{
              width: 100%;
              height: 20px;
              line-height: 20px;
              background-color: #e6eaf0;
              border-radius: 4px 4px 0px 0px;
              color: #2a3138;
              font-size: 12px;
              margin-top: 10px;
              text-align: center;
            }
            .time2{
              height: 30px;
              line-height: 30px;
              background-color: #f5f6fa;
              border-radius: 0 0 4px 4px;
              font-size: 18px;
              text-align: center;
              color: #2a3138;
            }
          }
          .name{
            color: #2a3138;
            font-size: 16px;
            line-height: 70px;
            width: calc(100% - 100px);
          }
        }
        .itemclass1:hover{
          .name{
            color: #0a7afc;
          }
          .time1{
            color: #0a7afc;
            background-color: #f2faff;
          }
          .time2{
            color: #fff;
            background-color: #0a7afc;
          }
        }
      }

    }

    .itemcontent1{
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .logoitem{
        width: 19%;
        height: 90px*0.9;
        background-color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 1%;
        margin-bottom: 10px;
        cursor: pointer;
        img{
          width: 35px;
          margin-right: 10px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/home/information.vue